var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "checkout-page-container",
          attrs: { id: "checkout-page" }
        },
        [
          _vm.checkOutStep === _vm.shippingStep
            ? _c("checkout-shipping", {
                attrs: { createStudio: _vm.createStudio }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.checkOutStep === _vm.projectInfoStep
            ? _c("pc-checkout-project-information", {
                attrs: { "user-email": _vm.userEmail }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.checkOutStep === _vm.reviewBasketStep
            ? _c("pc-checkout-review-basket", {
                attrs: {
                  listItemTitle: _vm.getMainHeading,
                  createStudio: _vm.createStudio
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.getGtmEventCheckoutItems !== undefined &&
          _vm.getGtmEventCheckoutItems.length > 0
            ? _c("pc-gtm-event-logger", {
                key: _vm.getGtmEventCheckoutItems.length,
                attrs: {
                  eventName: _vm.GTMEventName,
                  checkoutProducts: _vm.getGtmEventCheckoutItems || []
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("shipping-address-modal"),
      _vm._v(" "),
      _c("address-suggestion-modal"),
      _vm._v(" "),
      _c("pc-page-loader", { attrs: { loader: _vm.loader } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }